// extracted by mini-css-extract-plugin
export default {"packsPage":"PacksPage_packsPage__487f1","contentContainer":"PacksPage_contentContainer__zuf0p"};